import React from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function Aide() {
  const location = useLocation();
  React.useEffect(() => {
    if (location.hash === "#contact") {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [location]);
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container page-content fade-in" style={{ maxWidth: 760 }} data-testid="aide-page">
        <p className="eyebrow">AIDE</p>
        <h1>Besoin d'un coup de main ?</h1>

        <section id="contact" className="contact-section" data-testid="aide-contact-section">
          <h2 data-testid="aide-contact-title">Une question ? Écris-moi</h2>
          <p className="contact-text" data-testid="aide-contact-availability">Support disponible 24 h sur 24.</p>
          <a
            href="mailto:support.idevorai@gmail.com"
            className="contact-email"
            data-testid="aide-contact-email"
          >
            support.idevorai@gmail.com
          </a>
          <div>
            <a
              href="mailto:support.idevorai@gmail.com"
              className="btn btn-primary contact-btn"
              data-testid="aide-contact-button"
            >
              M'écrire
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
